import { render, staticRenderFns } from "./ManageImages.vue?vue&type=template&id=57a2339b"
import script from "./ManageImages.vue?vue&type=script&lang=ts"
export * from "./ManageImages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports